/*
  AdWhales – support for products with more than 250 variants.
  Shopify only exposes the first 250 variants to Liquid / product JSON, so the
  theme's variant picker could not find (or showed as unavailable) any
  combination beyond #250. For those products this file asks Shopify to resolve
  the selected combination (option_values + Section Rendering API) and updates
  the picker, price, stock, media and the variant id sent to the cart.
  Loaded only on products with more than 250 variants (see product-variant-options.liquid).
*/
(function () {
  if (window.__hvVariantsLoaded) return;
  window.__hvVariantsLoaded = true;

  var PICKER = 'variant-radios, variant-selects';

  function readData(root) {
    var el = root && root.querySelector('[data-hv-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyAvailability(picker, data) {
    if (!data || !Array.isArray(data.options)) return;
    var radios = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
    data.options.forEach(function (opt) {
      radios.forEach(function (input) {
        if (input.name !== opt.name) return;
        for (var i = 0; i < opt.values.length; i++) {
          if (opt.values[i].name === input.value) {
            input.classList.toggle('disabled', !opt.values[i].available);
            break;
          }
        }
      });
    });
  }

  function selectedOptions(picker) {
    return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function optionValueIds(data, options) {
    var ids = [];
    data.options.forEach(function (opt, index) {
      for (var i = 0; i < opt.values.length; i++) {
        if (opt.values[i].name === options[index]) {
          ids.push(opt.values[i].id);
          break;
        }
      }
    });
    return ids;
  }

  function onChange(picker) {
    var data = picker.__hvData || readData(picker);
    if (!data) return;

    var options = picker.options && picker.options.length ? picker.options : selectedOptions(picker);
    var ids = optionValueIds(data, options);
    var key = options.join('|');
    picker.__hvKey = key;

    var sectionId = picker.dataset.originalSection || picker.dataset.section;
    var url = picker.dataset.url + '?option_values=' + ids.join(',') + '&section_id=' + sectionId;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        if (picker.__hvKey !== key) return;
        var html = new DOMParser().parseFromString(text, 'text/html');
        var newPicker =
          html.querySelector('variant-radios[data-section="' + sectionId + '"]') ||
          html.querySelector('variant-selects[data-section="' + sectionId + '"]') ||
          html;
        var newData = readData(newPicker);
        if (!newData) return;

        picker.__hvData = newData;
        applyAvailability(picker, newData);

        var variant = newData.variant;
        var matches =
          variant &&
          Array.isArray(variant.options) &&
          variant.options.every(function (o, i) {
            return options[i] === o;
          });
        if (!matches) return; // combination does not exist – theme already shows "Unavailable"

        // Theme already resolved the same variant (it was within the first 250) – nothing else to do
        if (picker.currentVariant && picker.currentVariant.id === variant.id) return;

        var list = picker.getVariantData ? picker.getVariantData() : null;
        if (list && !list.some(function (v) { return v.id === variant.id; })) list.push(variant);

        picker.currentVariant = variant;
        if (picker.updateMedia) picker.updateMedia();
        if (picker.updateURL) picker.updateURL();
        if (picker.updateVariantInput) picker.updateVariantInput();
        if (picker.updatePickupAvailability) picker.updatePickupAvailability();
        if (picker.renderProductInfo) picker.renderProductInfo();
        if (picker.updateShareUrl) picker.updateShareUrl();
      })
      .catch(function () {});
  }

  // Runs after the theme's own change handler (bubbling to document)
  document.addEventListener('change', function (event) {
    var picker = event.target && event.target.closest && event.target.closest(PICKER);
    if (!picker || !picker.querySelector('[data-hv-data]')) return;
    onChange(picker);
  });

  function init() {
    document.querySelectorAll(PICKER).forEach(function (picker) {
      var data = readData(picker);
      if (!data) return;
      picker.__hvData = data;
      applyAvailability(picker, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
